import SearchModal from "../../../SearchModal";
import ParamsPicklist from "../../../../Types/ParamsPicklist";
import SelectMultipleOptionPanier from '../../../SelectMultipleOptionPanier';
import { useState, useEffect } from 'react';
import {
    Box, Grid, Button, Dialog, DialogContent, DialogActions,
    Stack, IconButton, Paper, Typography, Chip,
    Tooltip, Divider, Alert, Fade, LinearProgress
} from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import SweetAlert from'sweetalert2'
import InputForm from "../../../InputT";
import CheckboxF from '../../../ChexBox';
import SearInputG from "../../../SearchInput";
import SelectOption from '../../../SelectOption';
import { ParamsQardCompteGl } from "../../../../Models/ParamsQard";

 
let searchPlancp: ParamsPicklist = { CodeAgence: 'E', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL",Colagence: "categocpt", Choix: 39,tablelength:'societe',collength:'LenPlancp' }
const searchParamsAgence: ParamsPicklist  = { CodeAgence: '', Table: "Agence",     Colonne1: "CODAGE",    Colonne2: "LIBELLE",     Colagence: '101', Choix: 22 };


const makeSearchParamsCompte = (agence: string): ParamsPicklist => ({
    CodeAgence: agence, Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT",
    Colagence: 'AGCCPT' , Choix: 22, colfiltre: 'TYPCPT', valfiltre: 'I'
});

// ─── Config colonnes ──────────────────────────────────────────────────────────
const COLUMNS = [
    { key: 'CodeAgence',         label: 'Agence',           width: 110 },
    { key: 'CompteCharity',     label: 'Compte charity',      width: 130 },
    { key: 'ComptePromesseOctroi',     label: "Compte promesse d'octroie",      width: 130 },
    { key: 'CompteTvaDifferee', label: 'Compte Tva Differée', width: 145 },
    { key: 'CompteTvaCollecte', label: 'Compte Tva Collectée', width: 145 }
];


const emptyForm = (): Omit<ParamsQardCompteGl, 'Id' > => ({
    CodeAgence: '', LibelleAgence: '',ComptePromesseOctroi:'',
    CompteCharity: '', CompteTvaDifferee: '', CompteTvaCollecte: ''
});

// ─── Styles thead ─────────────────────────────────────────────────────────────
const thStyle: React.CSSProperties = {
    fontWeight: 700, fontSize: 11, color: '#fff', backgroundColor: '#2A6596',
    letterSpacing: 0.4, textTransform: 'uppercase', whiteSpace: 'nowrap',
};

interface Tab1Props {
    etatG?: boolean;
    form?: any;
    /** Lignes GL chargées depuis Typegarantie (consultation) */
    glRows: ParamsQardCompteGl[];
    /** Callback pour remonter les modifications à Typegarantie */
    setGlRows: React.Dispatch<React.SetStateAction<ParamsQardCompteGl[]>>;
}


const Tab2=({ etatG, form, glRows, setGlRows }: Tab1Props)=>{
 
    const [openModal, setOpenModal]     = useState(false);
     const [editingRow, setEditingRow]   = useState<ParamsQardCompteGl | null>(null);
     const [modalForm, setModalForm]     = useState(emptyForm());
     const [saving, setSaving]           = useState(false);
 
     // Synchronise le form AntD à chaque changement de glRows
     useEffect(() => {
         if (form) form.setFieldValue('ComptesGLAgences', glRows);
     }, [glRows, form]);
 
     // ── Handlers modal ──────────────────────────────────────────────────────
     const handleOpenAdd = () => {
         setEditingRow(null);
         setModalForm(emptyForm());
         form?.resetFields([
         "CodeAgence",
         "CompteCharity",
         "ComptePromesseOctroi",
         "CompteTvaDifferee",
         "CompteTvaCollecte",

     ]);
         setOpenModal(true);
     };
 
     const handleChangeAgence= () => {
          form?.resetFields([
         "CompteCharity",
         "ComptePromesseOctroi",
         "CompteTvaDifferee",
         "CompteTvaDifferee"
     ]);
        
     };
  
 
     const handleOpenEdit = (row: ParamsQardCompteGl) => {
         setEditingRow(row);
         setModalForm({ ...row });
         setOpenModal(true);
         form?.setFieldsValue({
         CodeAgence: row.CodeAgence,
         CompteCharity:row.CompteCharity,
         ComptePromesseOctroi:row.ComptePromesseOctroi,
         CompteTvaDifferee:row.CompteTvaDifferee,
         CompteTvaCollecte:row.CompteTvaCollecte
       });
     };
 
     const handleClose = () => { setOpenModal(false); setEditingRow(null); };
 
     const handleField = (key: keyof ReturnType<typeof emptyForm>, value: string) =>
         setModalForm(prev => ({ ...prev, [key]: value }));
 
     const isFormValid = () =>
         modalForm.CodeAgence && 
         modalForm.CompteCharity ;
 
     // ── Sauvegarde (création ou mise à jour) ────────────────────────────────
     const handleSave = () => {
         if (!isFormValid()) return;
         setSaving(true);
         setTimeout(() => {
             if (editingRow) {
                 // UPDATE : mise à jour de la ligne dans l'état parent
                 setGlRows(prev =>
                     prev.map(r =>
                         r.Id === editingRow.Id
                             ? { ...modalForm, Id: editingRow.Id
                                 // status: 'modified' as const
                              }
                             : r
                     )
                 );
             } else {
                 // CREATE : vérification doublon puis ajout
                 if (glRows.some(r => r.CodeAgence === modalForm.CodeAgence)) {
                     setSaving(false);
                       SweetAlert.fire({ title: "Cette agence possède déjà une configuration comptable.", icon: "warning" });
                     
                     return;
                 }
                setGlRows(prev => [...prev,{ ...modalForm, Id: modalForm.CodeAgence } ]);
             }
             setSaving(false);
             handleClose();
         }, 500);
     };
 
     // ── Suppression ─────────────────────────────────────────────────────────
     const handleDelete = (id: string | number) => {
         setGlRows(prev => prev.filter(r => r.Id !== id));
     };

     // ── Colonnes du tableau (redimensionnables en tirant la bordure de l'en-tête) ──
     const glColumns: ColumnsType<ParamsQardCompteGl> = [
         ...COLUMNS.map((col) => ({
             title: col.label,
             dataIndex: col.key,
             width: col.width,
             ellipsis: true,
             onHeaderCell: () => ({ style: thStyle }),
             onCell: () => ({ style: { fontSize: 12, color: '#2d4a5e' } }),
             render: (v: any) => v || <span style={{ color: '#bbb', fontStyle: 'italic' }}>—</span>,
         })),
         {
             title: 'Actions',
             key: 'actions',
             width: 90,
             align: 'center' as const,
             onHeaderCell: () => ({ style: thStyle }),
             render: (_: any, row: ParamsQardCompteGl) => (
                 <Stack direction="row" spacing={0.5} justifyContent="center">
                     <Tooltip title="Modifier les comptes GL">
                         <IconButton size="small" onClick={() => handleOpenEdit(row)}
                             sx={{ bgcolor: '#e8f0fe', color: '#2A6596', '&:hover': { bgcolor: '#2A6596', color: '#fff' }, width: 28, height: 28 }}>
                             <EditIcon sx={{ fontSize: 15 }} />
                         </IconButton>
                     </Tooltip>
                     <Tooltip title="Supprimer">
                         <IconButton size="small" onClick={() => handleDelete(row.Id)}
                             sx={{ bgcolor: '#fdecea', color: '#c0392b', '&:hover': { bgcolor: '#c0392b', color: '#fff' }, width: 28, height: 28 }}>
                             <DeleteIcon sx={{ fontSize: 15 }} />
                         </IconButton>
                     </Tooltip>
                 </Stack>
             ),
         },
     ];


    return(
       <div className='tabItem'>
             <Box className="border" width="85%" position="absolute" sx={{ p: 2 }}>
                        {/* Colonne Gauche */}
                    <Grid container spacing={0}>    
                        <Grid item xs={12} sm={12} md={6} >
                            <SearchModal width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan engagement (30/31/32/D)" name="IDPLENG" form={form} /> 
                            <SearchModal width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan impayé    (3312/C)" name="IDPLIMPAYE" form={form} />
                            <SearchModal notRequired width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan créance immobilisée(332/D)" name="IDPLCRIMMO" form={form} /> 
                        </Grid>
                     
                        {/* Colonne Droite */}
                        <Grid item xs={12} sm={12} md={6} >
                            <SearchModal notRequired width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan pénalité impayée(Passif/Charité)" name="IDPLPENIMP" form={form} />
                            <SearchModal width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan provision créance douteuse" name="IDPLPROV" form={form} /> 
                            <SearchModal width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan créance douteuse(333/D)" name="IDPLCRDOUT" form={form} />
                            {/* <SearchModal notRequired width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan fond de garantie(9321->D)" name="IDPLFONDGAR" form={form} /> 
                            <SearchModal notRequired width={7} Titre="Recherche plan" Parametre={searchPlancp} label="Plan promesse octroi(9240->D)" name="IDPLPROMESS" form={form} />      */}
                        </Grid>
                  </Grid> 

        {/* ── Bloc tableau Comptes GL ── */}
                <Box sx={{  mt: 1, borderRadius: '12px',  border: '1px solid #e3edf7', overflow: 'hidden',  boxShadow: '0 2px 12px rgba(4,68,110,0.08)'}}>
                            <Box sx={{ px: 3, py: 1.8,background: 'linear-gradient(135deg, #04446e 0%, #2A6596 100%)', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                <Stack direction="row" alignItems="center" spacing={1.5}>
                                    <AccountBalanceIcon sx={{ color: '#B0D2F7', fontSize: 22 }} />
                                    <Box>
                                        <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 14, letterSpacing: 0.3 }}>
                                            Comptes GL par Agence
                                        </Typography>
                                        <Typography sx={{ color: '#B0D2F7', fontSize: 11 }}>
                                            {glRows.length} configuration{glRows.length !== 1 ? 's' : ''} enregistrée{glRows.length !== 1 ? 's' : ''}
                                        </Typography>
                                    </Box>
                                </Stack>
                                <Button
                                  disabled={!etatG}
                                    variant="contained" size="small"
                                    startIcon={<AddCircleOutlineIcon />}
                                    onClick={handleOpenAdd}
                                    sx={{ bgcolor: '#B0D2F7', color: '#04446e', fontWeight: 700,
                                        fontSize: 12, px: 2, borderRadius: '8px', textTransform: 'none',
                                        '&:hover': { bgcolor: '#fff', color: '#04446e' },
                                    }}
                                >
                                    Associer une agence
                                </Button>
                            </Box>
        
                            {/* Table (colonnes redimensionnables, pagination moderne) */}
                            <Table
                                size="small"
                                rowKey="Id"
                                columns={glColumns}
                                dataSource={glRows}
                                scroll={{ y: 260, x: 'max-content' }}
                                locale={{
                                    emptyText: (
                                        <Box sx={{ py: 5, textAlign: 'center' }}>
                                            <AccountBalanceIcon sx={{ fontSize: 40, color: '#c5d8ea', mb: 1 }} />
                                            <Typography sx={{ color: '#90a4b7', fontSize: 13 }}>
                                                Aucune configuration. Cliquez sur{' '}
                                                <b>« Associer une agence »</b> pour commencer.
                                            </Typography>
                                        </Box>
                                    ),
                                }}
                                pagination={glRows.length > 0 ? {
                                    defaultPageSize: 5,
                                    pageSizeOptions: [5, 10, 25],
                                    showSizeChanger: true,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} configuration(s)`,
                                    size: 'small',
                                    style: { marginRight: 16 },
                                } : false}
                            />
                        </Box>
             </Box>

           <Dialog
                open={openModal} onClose={handleClose}
                maxWidth="md" fullWidth
                TransitionComponent={Fade}
                PaperProps={{ sx: { borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(4,68,110,0.18)' } }}
            >
                {/* Header modal */}
                <Box sx={{
                    px: 3, py: 2,
                    background: 'linear-gradient(135deg, #04446e 0%, #2A6596 100%)',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                        <AccountBalanceIcon sx={{ color: '#B0D2F7', fontSize: 24 }} />
                        <Box>
                            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>
                                {editingRow ? 'Modifier la configuration GL' : 'Nouvelle configuration comptable'}
                            </Typography>
                            <Typography sx={{ color: '#B0D2F7', fontSize: 11 }}>
                                {editingRow
                                    ? `Agence ${editingRow.CodeAgence} — modification des comptes GL`
                                    : 'Associer les comptes GL à une agence'}
                            </Typography>
                        </Box>
                    </Stack>
                    <IconButton onClick={handleClose} sx={{ color: '#B0D2F7', '&:hover': { color: '#fff' } }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {saving && <LinearProgress sx={{ height: 3 }} />}

                <DialogContent sx={{ bgcolor: '#f7fafd', px: 3, pt: 3, pb: 1 }}>
                    <Alert
                        icon={<InfoOutlinedIcon fontSize="small" />} severity="info"
                        sx={{ mb: 2.5, fontSize: 12, borderRadius: '8px', bgcolor: '#e8f4fd', color: '#2A6596', border: '1px solid #b3d4f0' }}
                    >
                        Les champs <b>Agence</b>, <b>Transit</b> sont obligatoires.
                    </Alert>

                    {/* Section agence */}
                    <Paper elevation={0} sx={{ p: 2, mb: 2, borderRadius: '10px', border: '1px solid #dce8f3', bgcolor: '#fff' }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
                            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#2A6596' }} />
                            <Typography sx={{ fontWeight: 700, fontSize: 12, color: '#04446e', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                Identification de l'agence
                            </Typography>
                        </Stack>
                        <SelectOption
                            Size="large"
                            label={editingRow ? `Agence : ${editingRow.CodeAgence}` : "Sélectionner l'agence *"}
                            name="CodeAgence"
                            Parametre={searchParamsAgence}
                            onchange={(value: any) => {handleField('CodeAgence', value);handleChangeAgence();}}
                            disabled={!!editingRow}   // l'agence ne peut pas changer en mode édition
                        />
                        {editingRow && (
                            <Typography sx={{ mt: 0.5, fontSize: 11, color: '#90a4b7', fontStyle: 'italic' }}>
                                L'agence ne peut pas être modifiée — seuls les comptes GL sont éditables.
                            </Typography>
                        )}
                    </Paper>

                    {/* Section comptes GL */}
                    <Paper elevation={0} sx={{ p: 2, borderRadius: '10px', border: '1px solid #dce8f3', bgcolor: '#fff' }}>
                        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#00875A' }} />
                            <Typography sx={{ fontWeight: 700, fontSize: 12, color: '#04446e', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                Paramétrage des comptes généraux
                            </Typography>
                        </Stack>
                        <Grid container spacing={0}>
                            {[
                                // { field: 'GLCompteTransit',        label: 'Compte Transit (GL)',      required: true  },
                                { field: 'CompteCharity',       label: 'Compte Charity (GL)',       required: true  },
                                { field: 'ComptePromesseOctroi',     label: 'Compte de promesse (GL)',     required: false  },
                                { field: 'CompteTvaDifferee', label: 'Compte Tva Differee (GL)', required: false },
                                { field: 'CompteTvaCollecte',       label: 'Compte Tva Collecte',       required: false  },
                                // { field: 'GLCompteDeblocage',    label: 'Compte Deblocage (GL)',   required: false },
    
                            ].map(({ field, label, required }) => (
                                <Grid item xs={12} sm={6} key={field}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: '#5a7a90', mb: 0 }}>
                                        {label} {required && <span style={{ color: '#e53935' }}>*</span>}
                                    </Typography>
                                    <SelectOption
                                        Size="large" label="" name={field}
                                        Parametre={makeSearchParamsCompte(editingRow?.CodeAgence ?? modalForm.CodeAgence)}
                                        onchange={(value: any) => { handleField(field as any, value);}}
                                        disabled={!modalForm.CodeAgence && !editingRow}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        {!modalForm.CodeAgence && !editingRow && (
                            <Typography sx={{ mt: 1.5, fontSize: 11, color: '#90a4b7', fontStyle: 'italic', textAlign: 'center' }}>
                                Sélectionnez d'abord une agence pour activer les comptes GL.
                            </Typography>
                        )}
                    </Paper>
                </DialogContent>

                <Divider />
                <DialogActions sx={{ px: 3, py: 2, bgcolor: '#f7fafd', gap: 1 }}>
                    <Button
                        onClick={handleClose} variant="outlined" size="medium"
                        startIcon={<CloseIcon />}
                        sx={{
                            borderColor: '#c0392b', color: '#c0392b', borderRadius: '8px',
                            textTransform: 'none', fontWeight: 600,
                            '&:hover': { bgcolor: '#fdecea', borderColor: '#c0392b' },
                        }}
                    >
                        Annuler
                    </Button>
                    <Button
                        onClick={handleSave} variant="contained" size="medium"
                        disabled={!isFormValid() || saving}
                        startIcon={editingRow ? <SaveIcon /> : <CheckCircleIcon />}
                        sx={{
                            bgcolor: '#00875A', color: '#fff', borderRadius: '8px',
                            textTransform: 'none', fontWeight: 700, px: 3,
                            boxShadow: '0 4px 14px rgba(0,135,90,0.25)',
                            '&:hover': { bgcolor: '#006644' },
                            '&:disabled': { bgcolor: '#a5d6c5', color: '#fff' },
                        }}
                    >
                        {saving
                            ? 'Enregistrement...'
                            : editingRow ? 'Mettre à jour' : "Valider l'association"}
                    </Button>
                </DialogActions>
            </Dialog>
         </div>
  
    );
}


export default Tab2;